// Native
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { SharedModule } from '../modules/shared.module';

// Pages
import { DashboardModule} from './dashboard/dashboard.module';
import { AuthModule} from './auth/auth.module';
import { UiKitModule} from "./static/ui-kit/ui-kit.module";
import { UiTablesModule } from "./static/ui-tables/ui-tables.module";

// Components
import {PagesRoutesModule} from './pages-routes.module';
import {StoresModule} from './stores/stores.module';
import {StoreGroupsModule} from './store-groups/store-groups.module';
import {UsersModule} from './users/users.module';
import {PurchasesModule} from './purchases/purchases.module';
import {ProjectsModule} from './projects/projects.module';
import {ProductsModule} from './products/products.module';
import {ModeratorsModule} from './moderators/moderators.module';
import {AccountModule} from './account/account.module';
import {ActionModule} from './action/action.module';
import {StoreVersionModule} from './store-version/store-version.module';
import {StoreCollectionModule} from './store-collection/store-collection.module';
import {StoreKeyModule} from './store-key/store-key.module';
import {ReceiptModule} from './receipt/receipt.module';
import {ConfigModule} from './config/config.module';
import {DeletedUserModule} from './deleted-user/deleted-user.module';
import {CustomDataModule} from './custom-data/custom-data.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardModule,
    AuthModule,
    UiKitModule,
    UiTablesModule,
    PagesRoutesModule,
    StoresModule,
    StoreGroupsModule,
    UsersModule,
    AccountModule,
    PurchasesModule,
    ReceiptModule,
    ProjectsModule,
    ProductsModule,
    ModeratorsModule,
    ActionModule,
    StoreVersionModule,
    StoreCollectionModule,
    DeletedUserModule,
    StoreKeyModule,
    ConfigModule,
    CustomDataModule
  ]
})
export class PagesModule { }

